import { ICashflowStatRow } from '@app/framework/cash-flow/cashflow-table/cashflow.types';

const COMMITMENT_STATS: ICashflowStatRow[] = [
  {
    label: 'BUDGET',
    value: 0,
    tooltip: '',
    classes: 'bg-navy-300',
  },
  {
    label: 'COMMITTED',
    value: 0,
    tooltip: '',
    classes: 'bg-navy-700/10',
  },
  {
    label: 'REMAINING',
    value: 0,
    tooltip: '',
    classes: 'bg-navy-700/10',
  },
  {
    label: 'PAID',
    value: 0,
    tooltip: '',
    classes: 'bg-yellow-500/10',
  },
  {
    label: 'TO PAY',
    value: 0,
    tooltip: '',
    classes: 'bg-yellow-500/10',
  },
];

const PRIME_CONTRACT_STATS: ICashflowStatRow[] = [
  {
    label: 'BUDGET',
    value: 0,
    tooltip: '',
    classes: 'bg-navy-300',
  },
  {
    label: 'PRIME',
    value: 0,
    tooltip: '',
    classes: 'bg-navy-700/10',
  },
  {
    label: 'FUNDING',
    value: 0,
    tooltip: '',
    classes: 'bg-navy-700/10',
  },
  {
    label: 'REALIZED',
    value: 0,
    tooltip: '',
    classes: 'bg-green-150',
  },
  {
    label: 'TO REALIZE',
    value: 0,
    tooltip: '',
    classes: 'bg-green-150',
  },
];

const PRIME_V_COMMIT_STATS: ICashflowStatRow[] = [
  {
    label: 'ANTICIPATED FEE',
    value: 0,
    tooltip: '',
    classes: 'bg-green-150',
  },
  {
    label: 'PRIME',
    value: 0,
    tooltip: '',
    classes: 'bg-navy-300',
  },
  {
    label: 'ANTICIPATED INCOME',
    value: 0,
    tooltip: '',
    classes: 'bg-navy-300',
  },
  {
    label: 'COMMITTED',
    value: 0,
    tooltip: '',
    classes: 'bg-blue-700/10',
  },
  {
    label: 'ANTICIPATED COSTS',
    value: 0,
    tooltip: '',
    classes: 'bg-blue-700/10',
  },
];

export enum CASHFLOW_VIEWS {
  COMMITMENTS = 0,
  PRIME_CONTRACT = 1,
  PRIME_V_COMMIT = 2,
}

export const CASHFLOW_CONSTANTS = {
  COMMITMENT_STATS,
  PRIME_CONTRACT_STATS,
  PRIME_V_COMMIT_STATS,
};
